import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { GlobalProvider } from '../../providers/global/global';
//import * as HighCharts from 'highcharts';

@IonicPage()
@Component({
  selector: 'page-consulta',
  templateUrl: 'consulta.html',
})
export class ConsultaPage {

  data: Observable<any>;
  periodo: any = 0;
  periodoDe: any;
  periodoAte: any;
  isenabled: boolean = true;
  date = new Date();
  currentDate = new Date(this.date.getTime() - (this.date.getTimezoneOffset() * 60000)).toISOString().slice(0, -5);
  tags: string[];
  pontos: any[];
  pontos2: any[];
  pontos3: any[];
  consulta: any;
  chartoptions: any;
  datavalue: boolean = false;
  Date = new Date();
  timestamp: any[];
  keys: any[];
  index: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public global: GlobalProvider, public loadingCtrl: LoadingController) {

  }


  // lineChart
  public lineChartData: Array<any> = [
    { data: [], label: 'Series A' },
    { data: [], label: 'Series B' },
    { data: [], label: 'Series C' }
  ];
  public lineChartLabels: Array<any> = [];
  public lineChartOptions: any = {
    responsive: true,
    scales: {
      xAxes: [{
        type: 'time',
        time: {
          displayFormats: {
            'hour': 'DD/MM HH:mm'
          }
        }
      }]
    }
  };

  
  public lineChartColors: Array<any> = [
    { // red
      backgroundColor: 'rgba(255,0,0,0)',
      borderColor: 'rgba(255,0,0,1)',
      pointBackgroundColor: 'rgba(255,0,0,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: 'rgba(255,0,0,0.5)',
      pointHoverBorderColor: 'rgba(255,0,0,0.8)'
    },
    { // dark grey
      backgroundColor: 'rgba(77,83,96,0)',
      borderColor: 'rgba(77,83,96,1)',
      pointBackgroundColor: 'rgba(77,83,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: 'rgba(77,83,96,0.5)',
      pointHoverBorderColor: 'rgba(77,83,96,1)'
    },
    { // blue
      backgroundColor: 'rgba(0,85,148,0)',
      borderColor: 'rgba(0,85,148,1)',
      pointBackgroundColor: 'rgba(0,85,148,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: 'rgba(0,85,148,0.5)',
      pointHoverBorderColor: 'rgba(0,85,148,0.8)'
    }
  ];
  public lineChartLegend: boolean = true;
  public lineChartType: string = 'line';

  // events
  public chartClicked(e: any): void {
    //console.log(e);
  }

  public chartHovered(e: any): void {
    //console.log(e);
  }

  changePeriod() {
    if (this.periodo == 0) {
      this.isenabled = true;
    }
    else if (this.periodo == 1) {
      this.isenabled = false;
      this.periodoDe = this.currentDate.slice(0, -9) + "T00:00";
      this.periodoAte = this.currentDate;
    }
    else if (this.periodo == 2) {
      this.isenabled = false;
      this.Date.setHours(this.Date.getHours() - 27);
      this.periodoDe = this.Date.toISOString().slice(0, -14) + "T00:00";
      this.periodoAte = this.Date.toISOString().slice(0, -14) + "T23:59";
    }
    else if (this.periodo == 3) {
      this.isenabled = false;
      this.Date.setHours(this.Date.getHours() - 15);
      this.periodoDe = this.Date.toISOString().slice(0, -5);
      this.periodoAte = this.currentDate;
    }
    else if (this.periodo == 4) {
      this.isenabled = false;
      this.Date.setHours(this.Date.getHours() - 171);
      this.periodoDe = this.Date.toISOString().slice(0, -5);
      this.periodoAte = this.currentDate;
    }
    else {
      this.isenabled = false;
    }

    this.Date = new Date();
  }

  ionViewDidLoad() {
    try {
      var url = 'http://iot.digicomp.com.br/api/public/ping/consulta/tags';
      this.global.check_jwt();

      let body = new FormData();
      body.append('db', this.global.banco);
      body.append('tabela', 'menu_app');
      body.append('jwt', this.global.token);

      this.data = this.http.post(url, body);
      this.data.subscribe(data => {
        //console.log(data);
        if (data == null) {
          document.getElementById("demo").innerHTML = "Nenhum registro encontrado!";
        }
        else {
          this.tags = data;
        }
      });
    }
    catch (e) {
      console.error(e);
    }

  }

  consultar() {
    //document.getElementById("de").innerHTML = this.periodoDe;
    //document.getElementById("ate").innerHTML = this.periodoAte;
    //document.getElementById("demo").innerHTML = this.consulta;

    if (this.periodoDe == undefined) {
      alert("Data incorreta! O período inicial deve ser selecionado.");
      return;
    }

    if (this.periodoAte == undefined) {
      alert("Data incorreta! O período final deve ser selecionado.");
      return;
    }

    if (this.periodoDe > this.periodoAte) {
      alert("Data incorreta! O período inicial deve ser menor que o período final.");
      return;
    }

    if (this.consulta == undefined) {
      alert("Consulta não selecionada. Favor selecionar um item para realizar a consulta.");
      return;
    }

    this.index = this.consulta.toString().split(',').length;
    if (this.index > 3) {
      alert("Não é permitido selecionar mais que 3 itens!");
      return;
    }

    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      duration: 30000
    });
    loader.present();

    this.datavalue = false;

    try {
      var url = 'http://iot.digicomp.com.br/api/public/ping/consulta/valores';
      this.global.check_jwt();

      let body = new FormData();
      body.append('db', this.global.banco);
      body.append('tabela', this.global.banco + "_mg");
      body.append('tag', this.consulta);
      body.append('periodoInicio', this.periodoDe);
      body.append('periodoFim', this.periodoAte);
      body.append('jwt', this.global.token);
      //console.log("body", body);

      this.data = this.http.post(url, body);
      this.data.subscribe(data => {
        console.log(data);
        this.keys = Object.keys(data);

        if (this.index == 1) {
          for (let i = 0; i < data[this.keys[0]].valor.length; i++) {
            this.pontos[i] = Number.parseFloat(data[this.keys[0]].valor[i]).toFixed(2);
            this.timestamp[i] = data[this.keys[0]].timestamp[i];
          }
          //console.log(this.pontos);
        }
        else if (this.index == 2) {
          for (let i = 0; i < data[this.keys[1]].valor.length; i++) {
            this.pontos[i] = Number.parseFloat(data[this.keys[0]].valor[i]).toFixed(2);
            this.pontos2[i] = Number.parseFloat(data[this.keys[1]].valor[i]).toFixed(2);
            this.timestamp[i] = data[this.keys[1]].timestamp[i];
          }
          //console.log(this.pontos);
          //console.log(this.pontos2);
        }
        else if (this.index == 3) {
          for (let i = 0; i < data[this.keys[2]].valor.length; i++) {
            this.pontos[i] = Number.parseFloat(data[this.keys[0]].valor[i]).toFixed(2);
            this.pontos2[i] = Number.parseFloat(data[this.keys[1]].valor[i]).toFixed(2);
            this.pontos3[i] = Number.parseFloat(data[this.keys[2]].valor[i]).toFixed(2);
            this.timestamp[i] = data[this.keys[2]].timestamp[i];
          }
          //console.log(this.pontos);
          //console.log(this.pontos2);
          //console.log(this.pontos3);
        }

        //console.log(this.timestamp);

        loader.dismiss();
        this.datavalue = true;
      });
    }
    catch (e) {
      console.error(e);
    }
    this.timestamp = [];
    this.lineChartLabels = this.timestamp;

    if (this.index == 1) {
      this.pontos = [];
      console.log(this.pontos)
      console.log(this.pontos[0])
      this.lineChartData = [
        { data: this.pontos, label: this.consulta.toString().split(',')[0] }
      ];
    }
    else if (this.index == 2) {
      this.pontos = [];
      this.pontos2 = [];
      this.lineChartData = [
        { data: this.pontos, label: this.consulta.toString().split(',')[0] },
        { data: this.pontos2, label: this.consulta.toString().split(',')[1] }
      ];
    }
    else if (this.index == 3) {
      this.pontos = [];
      this.pontos2 = [];
      this.pontos3 = [];
      this.lineChartData = [
        { data: this.pontos, label: this.consulta.toString().split(',')[0] },
        { data: this.pontos2, label: this.consulta.toString().split(',')[1] },
        { data: this.pontos3, label: this.consulta.toString().split(',')[2] }
      ];
    }

  }


}



// WEBPACK FOOTER //
// ./src/pages/consulta/consulta.ts